import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public url: string = null; // stores the fully qualified URL of the service
  public baseUri: string = null;
  private uri = ''; // stores the uri for the service
  private httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'timeout': '180000'
  });
  protected apiUri = '/tmssserver/api';
  protected publicApiUri = '/tmssserver/api/public';

  public options = {
    headers: this.httpHeaders,
    search: {}
  };
  // This will host the host name where we are running the application
  public hostName = new BehaviorSubject<string>('');
  // This will hold the customer Name associated with the LID
  public customerName = new BehaviorSubject<string>('');

  constructor(protected http: HttpClient) {
  }

  setHost(host: string) {
    this.hostName.next(host);
  }

  setUri(uri: string) {

    // hostname doesn't seem to be getting initialized at all so this code may need to be removed
    if (null != this.hostName.getValue() && this.hostName.getValue().length > 0) {
      this.url = this.hostName.getValue() + '/' + uri;
    } else {
      this.url = uri;
    }
    this.uri = uri;

    if (this.baseUri === null) {
      this.baseUri = uri;
    }
  }

  getUri() {
    return this.uri;
  }

  getHost() {
    return this.hostName.getValue();
  }

  getBaseUri() {
    return this.baseUri;
  }

  getUrl() {
    return this.url;
  }

  get(options?: object): Observable<any> {
    return this.http.get(this.url, options);
  }

  create(resource, path?: string): any {
    let updatePath = '';
    if (path) {
      updatePath = this.baseUri + path;
    } else {
      updatePath = this.baseUri;
    }
    return this.http.post(updatePath, resource, this.options);
  }

  update(resource, path?: string) {
    let updatePath = '';
    if (path) {
      updatePath = this.url + path;
    } else {
      updatePath = this.url;
    }
    return this.http.put(updatePath, resource);
  }

  deleteWithPut(id: any) {
    return this.http.put(this.url + id + '/delete', null);
  }

  handleError(error: Response) {
    if (error.status === 404) {
      return throwError(new NotFoundError());
    }
    if (error.status === 400) {
      return throwError(new BadInput());
    }
    return throwError(new AppError());
  }
}

/**
 * Default application error handler
 */
export class AppError {
  constructor(public originalErr?: any) {
  }
}

export class NotFoundError extends AppError {
}

export class BadInput extends AppError {
}
